module.exports = __webpack_public_path__ + "img/forget_password_dark.bee6b1ac.svg";